<template>
  <div>
    <BaseTitle :title="$t('content.discussion')" :yearPeriode="titleData" />
    <v-card>
      <div class="pa-5 d-flex justiy-space-between align-items section-header active">
        <div class="student-title">{{ datas.subject }}</div>
      </div>
      <div class="assignment-content">
        <v-row class="border-item">
          <v-col md="1" align="center">
            <div class="pa-3">
              <img v-if="datas.imageUrl" :src="datas.imageUrl" class="user-photo" />
              <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
            </div>
          </v-col>
          <v-col md="10" class="mt-5">
            <div class="d-block mb-2">
              <span class="mr-3 body-content">
                {{ $t('content.by') }} :
                <strong>{{ datas.by }}</strong>
              </span>
            </div>
            <div class="d-block">
              <div>
                <span>
                  <span class="mr-3 body-content">
                    {{ $t('table.date') }} :
                    <strong class="body-content-date">{{ datas.date }}</strong>
                  </span>
                </span>
                <div class="mb-3 mt-7">
                  <div style="overflow-x: auto;">
                    <article v-if="datas.description" class="my-5 html-prose" v-html="datas.description" />
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
            </div>
            <v-divider />
            <template>
              <div class="d-flex justify-start align-center mt-6">
                <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(datas)">{{
                  $t('content.add_comment')
                }}</v-btn>
              </div>
            </template>
            <v-expand-transition mode="in-out">
              <div v-show="datas.addComment">
                <v-card-text>
                  <div>
                    <text-editor v-model="datas.komen" @input="v => (comments.parent = v)" />
                  </div>
                  <div class="d-flex justify-end align-center">
                    <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="dropDownAdd(datas)">{{ $t('back') }}</v-btn>
                    <v-btn color="primary" class="btn-primary-custom mt-5" :disabled="!comments.parent" @click="submitData(datas)">
                      {{ $t('submit') }}
                    </v-btn>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card v-for="(comment, index) in datas.comments" :key="index">
      <!-- parent  -->
      <div
        class="assignment-content"
        v-if="
          (comment.childCommentHidden === false && !isStudent) ||
            (comment.childCommentHidden === false && isStudent) ||
            (comment.childCommentHidden === true && !isStudent)
        "
      >
        <v-row class="border-item">
          <v-col md="1" align="center">
            <div class="pa-3 mt-5">
              <img v-if="comment.imageUrl" :src="comment.imageUrl" class="user-photo" />
              <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
            </div>
          </v-col>
          <v-col md="11" class="mt-5 mb-5">
            <div class="reply-card pa-5">
              <div class="d-block mb-2">
                <span class="mr-3 body-content">
                  {{ $t('content.by') }} :
                  <strong>{{ comment.fullName }}</strong>
                </span>
              </div>
              <div class="d-block">
                <div>
                  <span>
                    <span class="mr-3 body-content">
                      {{ $t('table.date') }} :
                      <strong class="body-content-date">{{ comment.date }}</strong>
                    </span>
                  </span>
                  <div class="mb-3 mt-7">
                    <div style="overflow-x: auto;">
                      <article v-if="comment.comment" class="container mb-5" v-html="comment.comment" />
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex d-block mt-6 justify-start align-center">
              <div class="d-flex justify-end align-center">
                <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(comment)">{{
                  $t('content.add_comment')
                }}</v-btn>
                <v-btn color="primary" v-if="comment.editable" class="btn-primary-custom mr-3 mb-5" @click="dropDown(comment)">{{
                  $t('edit')
                }}</v-btn>
                <v-btn color="red" v-if="comment.deleteable" class="btn-primary-custom mr-3 mb-5" outlined @click="dialogDeletePop(comment)">{{
                  $t('delete')
                }}</v-btn>
                <v-btn
                  :color="comment.childCommentHidden === false ? `blue-grey` : `green`"
                  v-if="comment.canHideChildComment"
                  class="btn-primary-custom mr-3 mb-5"
                  outlined
                  @click="dialogHidePop(comment)"
                  >{{ $t(`${comment.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                >
              </div>
            </div>
            <v-divider />
            <v-expand-transition>
              <div v-show="comment.addComment">
                <v-card-text>
                  <div>
                    <text-editor v-model="comment.komen" @input="v => (comments.parent = v)" />
                  </div>
                  <div class="d-flex justify-end align-center">
                    <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="dropDownAdd(comment)">{{ $t('back') }}</v-btn>
                    <v-btn color="primary" class="btn-primary-custom mt-5" :disabled="!comments.parent" @click="submitData(comment)">
                      {{ $t('submit') }}
                    </v-btn>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>

            <!-- 1 row  -->
            <div>
              <div v-for="(commen1, index) in comment.comments" :key="index" class="assignment-content">
                <v-row
                  class="border-item"
                  v-if="
                    (commen1.childCommentHidden === false && !isStudent) ||
                      (commen1.childCommentHidden === false && isStudent) ||
                      (commen1.childCommentHidden === true && !isStudent)
                  "
                >
                  <v-col md="1" align="center">
                    <div class="pa-3 mt-5">
                      <img v-if="commen1.imageUrl" :src="commen1.imageUrl" class="user-photo" />
                      <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                    </div>
                  </v-col>
                  <v-col md="11" class="mt-5 mb-5">
                    <div class="reply-card pa-5">
                      <div class="d-block mb-2">
                        <span class="mr-3 body-content">
                          {{ $t('content.by') }} :
                          <strong>{{ commen1.fullName }}</strong>
                        </span>
                      </div>
                      <div class="d-block">
                        <div>
                          <span>
                            <span class="mr-3 body-content">
                              {{ $t('table.date') }} :
                              <strong class="body-content-date">{{ commen1.date }}</strong>
                            </span>
                          </span>
                          <div class="mb-3 mt-7">
                            <div style="overflow-x: auto;">
                              <article v-if="commen1.comment" class="container mb-5" v-html="commen1.comment" />
                              <span v-else>-</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex d-block mt-6 justify-start align-center">
                      <div class="d-flex justify-end align-center">
                        <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(commen1)">{{
                          $t('content.add_comment')
                        }}</v-btn>
                        <v-btn color="primary" v-if="commen1.editable" class="btn-primary-custom mr-3 mb-5" @click="dropDown(commen1)">{{
                          $t('edit')
                        }}</v-btn>
                        <v-btn
                          color="red"
                          v-if="commen1.deleteable"
                          class="btn-primary-custom mr-3 mb-5"
                          outlined
                          @click="dialogDeletePop(commen1)"
                          >{{ $t('delete') }}</v-btn
                        >
                        <v-btn
                          :color="commen1.childCommentHidden === false ? `blue-grey` : `green`"
                          v-if="commen1.canHideChildComment"
                          class="btn-primary-custom mr-3 mb-5"
                          outlined
                          @click="dialogHidePop(commen1)"
                          >{{ $t(`${commen1.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                        >
                      </div>
                    </div>
                    <v-divider />
                    <v-expand-transition>
                      <div v-show="commen1.addComment">
                        <v-card-text>
                          <div>
                            <text-editor v-model="commen1.komen" @input="v => (comments.child = v)" />
                          </div>
                          <div class="d-flex justify-end align-center">
                            <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="dropDownAdd(commen1)">{{
                              $t('back')
                            }}</v-btn>
                            <v-btn color="primary" class="btn-primary-custom mt-5" :disabled="!comments.child" @click="submitData(commen1)">
                              {{ $t('submit') }}
                            </v-btn>
                          </div>
                        </v-card-text>
                      </div>
                    </v-expand-transition>

                    <!-- 2 row  -->
                    <div>
                      <div v-for="(commen2, index) in commen1.comments" :key="index" class="assignment-content">
                        <v-row
                          class="border-item"
                          v-if="
                            (commen2.childCommentHidden === false && !isStudent) ||
                              (commen2.childCommentHidden === false && isStudent) ||
                              (commen2.childCommentHidden === true && !isStudent)
                          "
                        >
                          <v-col md="1" align="center">
                            <div class="pa-3 mt-5">
                              <img v-if="commen2.imageUrl" :src="commen2.imageUrl" class="user-photo" />
                              <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                            </div>
                          </v-col>
                          <v-col md="11" class="mt-5 mb-5">
                            <div class="reply-card pa-5">
                              <div class="d-block mb-2">
                                <span class="mr-3 body-content">
                                  {{ $t('content.by') }} :
                                  <strong>{{ commen2.fullName }}</strong>
                                </span>
                              </div>
                              <div class="d-block">
                                <div>
                                  <span>
                                    <span class="mr-3 body-content">
                                      {{ $t('table.date') }} :
                                      <strong class="body-content-date">{{ commen2.date }}</strong>
                                    </span>
                                  </span>
                                  <div class="mb-3 mt-7">
                                    <div style="overflow-x: auto;">
                                      <article v-if="commen2.comment" class="container mb-5" v-html="commen2.comment" />
                                      <span v-else>-</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex d-block mt-6 justify-start align-center">
                              <div class="d-flex justify-end align-center">
                                <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(commen2)">{{
                                  $t('content.add_comment')
                                }}</v-btn>

                                <v-btn color="primary" v-if="commen2.editable" class="btn-primary-custom mr-3 mb-5" @click="dropDown(commen2)">{{
                                  $t('edit')
                                }}</v-btn>
                                <v-btn
                                  color="red"
                                  v-if="commen2.deleteable"
                                  class="btn-primary-custom mr-3 mb-5"
                                  outlined
                                  @click="dialogDeletePop(commen2)"
                                  >{{ $t('delete') }}</v-btn
                                >
                                <v-btn
                                  :color="commen2.childCommentHidden === false ? `blue-grey` : `green`"
                                  v-if="commen2.canHideChildComment"
                                  class="btn-primary-custom mr-3 mb-5"
                                  outlined
                                  @click="dialogHidePop(commen2)"
                                  >{{ $t(`${commen2.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                                >
                              </div>
                            </div>
                            <v-divider />
                            <v-expand-transition>
                              <div v-show="commen2.addComment">
                                <v-card-text>
                                  <div>
                                    <text-editor v-model="commen2.komen" @input="v => (comments.grandchild = v)" />
                                  </div>
                                  <div class="d-flex justify-end align-center">
                                    <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="dropDownAdd(commen2)">{{
                                      $t('back')
                                    }}</v-btn>
                                    <v-btn
                                      color="primary"
                                      class="btn-primary-custom mt-5"
                                      :disabled="!comments.grandchild"
                                      @click="submitData(commen2)"
                                    >
                                      {{ $t('submit') }}
                                    </v-btn>
                                  </div>
                                </v-card-text>
                              </div>
                            </v-expand-transition>
                            <!-- 3 row  -->
                            <div>
                              <div v-for="(commen3, index) in commen2.comments" :key="index" class="assignment-content">
                                <v-row
                                  class="border-item"
                                  v-if="
                                    (commen3.childCommentHidden === false && !isStudent) ||
                                      (commen3.childCommentHidden === false && isStudent) ||
                                      (commen3.childCommentHidden === true && !isStudent)
                                  "
                                >
                                  <v-col md="1" align="center">
                                    <div class="pa-3 mt-5">
                                      <img v-if="commen3.imageUrl" :src="commen3.imageUrl" class="user-photo" />
                                      <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                                    </div>
                                  </v-col>
                                  <v-col md="11" class="mt-5 mb-5">
                                    <div class="reply-card pa-5">
                                      <div class="d-block mb-2">
                                        <span class="mr-3 body-content">
                                          {{ $t('content.by') }} :
                                          <strong>{{ commen3.fullName }}</strong>
                                        </span>
                                      </div>
                                      <div class="d-block">
                                        <div>
                                          <span>
                                            <span class="mr-3 body-content">
                                              {{ $t('table.date') }} :
                                              <strong class="body-content-date">{{ commen3.date }}</strong>
                                            </span>
                                          </span>
                                          <div class="mb-3 mt-7">
                                            <div style="overflow-x: auto;">
                                              <article v-if="commen3.comment" class="container mb-5" v-html="commen3.comment" />
                                              <span v-else>-</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex d-block mt-6 justify-start align-center">
                                      <div class="d-flex justify-end align-center">
                                        <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(commen3)">{{
                                          $t('content.add_comment')
                                        }}</v-btn>

                                        <v-btn
                                          color="primary"
                                          v-if="commen3.editable"
                                          class="btn-primary-custom mr-3 mb-5"
                                          @click="dropDown(commen3)"
                                          >{{ $t('edit') }}</v-btn
                                        >
                                        <v-btn
                                          color="red"
                                          v-if="commen3.deleteable"
                                          class="btn-primary-custom mr-3 mb-5"
                                          outlined
                                          @click="dialogDeletePop(commen3)"
                                          >{{ $t('delete') }}</v-btn
                                        >
                                        <v-btn
                                          :color="commen3.childCommentHidden === false ? `blue-grey` : `green`"
                                          v-if="commen3.canHideChildComment"
                                          class="btn-primary-custom mr-3 mb-5"
                                          outlined
                                          @click="dialogHidePop(commen3)"
                                          >{{ $t(`${commen3.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                                        >
                                      </div>
                                    </div>
                                    <v-divider />
                                    <v-expand-transition>
                                      <div v-show="commen3.addComment">
                                        <v-card-text>
                                          <div>
                                            <text-editor v-model="commen3.komen" @input="v => (comments.greatGrandchild = v)" />
                                          </div>
                                          <div class="d-flex justify-end align-center">
                                            <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="dropDownAdd(commen3)">{{
                                              $t('back')
                                            }}</v-btn>
                                            <v-btn
                                              color="primary"
                                              class="btn-primary-custom mt-5"
                                              :disabled="!comments.greatGrandchild"
                                              @click="submitData(commen3)"
                                            >
                                              {{ $t('submit') }}
                                            </v-btn>
                                          </div>
                                        </v-card-text>
                                      </div>
                                    </v-expand-transition>
                                    <!-- 4 row  -->
                                    <div>
                                      <div v-for="(commen4, index) in commen3.comments" :key="index" class="assignment-content">
                                        <v-row
                                          class="border-item"
                                          v-if="
                                            (commen4.childCommentHidden === false && !isStudent) ||
                                              (commen4.childCommentHidden === false && isStudent) ||
                                              (commen4.childCommentHidden === true && !isStudent)
                                          "
                                        >
                                          <v-col md="1" align="center">
                                            <div class="pa-3 mt-5">
                                              <img v-if="commen4.imageUrl" :src="commen4.imageUrl" class="user-photo" />
                                              <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                                            </div>
                                          </v-col>
                                          <v-col md="11" class="mt-5 mb-5">
                                            <div class="reply-card pa-5">
                                              <div class="d-block mb-2">
                                                <span class="mr-3 body-content">
                                                  {{ $t('content.by') }} :
                                                  <strong>{{ commen4.fullName }}</strong>
                                                </span>
                                              </div>
                                              <div class="d-block">
                                                <div>
                                                  <span>
                                                    <span class="mr-3 body-content">
                                                      {{ $t('table.date') }} :
                                                      <strong class="body-content-date">{{ commen4.date }}</strong>
                                                    </span>
                                                  </span>
                                                  <div class="mb-3 mt-7">
                                                    <div style="overflow-x: auto;">
                                                      <article v-if="commen4.comment" class="container mb-5" v-html="commen4.comment" />
                                                      <span v-else>-</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="d-flex d-block mt-6 justify-start align-center">
                                              <div class="d-flex justify-end align-center">
                                                <v-btn color="primary" class="btn-primary-custom mr-3 mb-5" outlined @click="dropDownAdd(commen4)">{{
                                                  $t('content.add_comment')
                                                }}</v-btn>

                                                <v-btn
                                                  color="primary"
                                                  v-if="commen4.editable"
                                                  class="btn-primary-custom mr-3 mb-5"
                                                  @click="dropDown(commen4)"
                                                  >{{ $t('edit') }}</v-btn
                                                >
                                                <v-btn
                                                  color="red"
                                                  v-if="commen4.deleteable"
                                                  class="btn-primary-custom mr-3 mb-5"
                                                  outlined
                                                  @click="dialogDeletePop(commen4)"
                                                  >{{ $t('delete') }}</v-btn
                                                >
                                                <v-btn
                                                  :color="commen4.childCommentHidden === false ? `blue-grey` : `green`"
                                                  v-if="commen4.canHideChildComment"
                                                  class="btn-primary-custom mr-3 mb-5"
                                                  outlined
                                                  @click="dialogHidePop(commen4)"
                                                  >{{ $t(`${commen4.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                                                >
                                              </div>
                                            </div>
                                            <v-divider />
                                            <v-expand-transition>
                                              <div v-show="commen4.addComment">
                                                <v-card-text>
                                                  <div>
                                                    <text-editor v-model="commen4.komen" @input="v => (comments.great2Grandchild = v)" />
                                                  </div>
                                                  <div class="d-flex justify-end align-center">
                                                    <v-btn
                                                      color="primary"
                                                      class="btn-primary-custom mr-3 mt-5"
                                                      outlined
                                                      @click="dropDownAdd(commen4)"
                                                      >{{ $t('back') }}</v-btn
                                                    >
                                                    <v-btn
                                                      color="primary"
                                                      class="btn-primary-custom mt-5"
                                                      :disabled="!comments.great2Grandchild"
                                                      @click="submitData(commen4)"
                                                    >
                                                      {{ $t('submit') }}
                                                    </v-btn>
                                                  </div>
                                                </v-card-text>
                                              </div>
                                            </v-expand-transition>
                                            <!-- 5 row  -->
                                            <div>
                                              <div v-for="(commen5, index) in commen4.comments" :key="index" class="assignment-content">
                                                <v-row
                                                  class="border-item"
                                                  v-if="
                                                    (commen5.childCommentHidden === false && !isStudent) ||
                                                      (commen5.childCommentHidden === false && isStudent) ||
                                                      (commen5.childCommentHidden === true && !isStudent)
                                                  "
                                                >
                                                  <v-col md="1" align="center">
                                                    <div class="pa-3 mt-5">
                                                      <img v-if="commen5.imageUrl" :src="commen5.imageUrl" class="user-photo" />
                                                      <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                                                    </div>
                                                  </v-col>
                                                  <v-col md="11" class="mt-5 mb-5">
                                                    <div class="reply-card pa-5">
                                                      <div class="d-block mb-2">
                                                        <span class="mr-3 body-content">
                                                          {{ $t('content.by') }} :
                                                          <strong>{{ commen5.fullName }}</strong>
                                                        </span>
                                                      </div>
                                                      <div class="d-block">
                                                        <div>
                                                          <span>
                                                            <span class="mr-3 body-content">
                                                              {{ $t('table.date') }} :
                                                              <strong class="body-content-date">{{ commen5.date }}</strong>
                                                            </span>
                                                          </span>
                                                          <div class="mb-3 mt-7">
                                                            <div style="overflow-x: auto;">
                                                              <article v-if="commen5.comment" class="container mb-5" v-html="commen5.comment" />
                                                              <span v-else>-</span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="d-flex d-block mt-6 justify-start align-center">
                                                      <v-btn
                                                        color="primary"
                                                        v-if="commen5.editable"
                                                        class="btn-primary-custom mr-3 mb-5"
                                                        @click="dropDown(commen5)"
                                                        >{{ $t('edit') }}</v-btn
                                                      >
                                                      <v-btn
                                                        color="red"
                                                        v-if="commen5.deleteable"
                                                        class="btn-primary-custom mr-3 mb-5"
                                                        outlined
                                                        @click="dialogDeletePop(commen5)"
                                                        >{{ $t('delete') }}</v-btn
                                                      >
                                                      <v-btn
                                                        :color="commen5.childCommentHidden === false ? `blue-grey` : `green`"
                                                        v-if="commen5.canHideChildComment"
                                                        class="btn-primary-custom mr-3 mb-5"
                                                        outlined
                                                        @click="dialogHidePop(commen5)"
                                                        >{{ $t(`${commen5.childCommentHidden === false ? `content.hide` : `paginate.show`}`) }}</v-btn
                                                      >
                                                    </div>
                                                    <v-divider class="mt-2" />
                                                  </v-col>
                                                </v-row>
                                              </div>
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3 mt-5" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDeleteBack">{{ $t('disagree') }}</v-btn>
          <v-btn text @click="deleteComment">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Hide -->
    <v-dialog v-model="dialogHide" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t(`${itemHide.childCommentHidden === false ? `hide_title` : `show_title`}`) }} </v-card-title>
        <v-card-text>{{ $t(`${itemHide.childCommentHidden === false ? `delete_hide` : `delete_show`}`) }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogHideBack"> {{ $t('disagree') }}</v-btn>
          <v-btn text @click="hideComment">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextEditor from '@/components/base/TextEditor.vue';
import BaseTitle from '@/components/base/Title';
import { mapGetters } from 'vuex';

export default {
  name: 'DisscusionView',
  components: {
    BaseTitle,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    detailDiscussion({ classId, courseId, discussionId }) {
      const { classId: currentClassId, courseId: currentCourseId, id: CurrentId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId && discussionId == CurrentId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update View Discussion' });
        setTimeout(() => {
          this.getData();
          // if (this.user.roleId === 5) {
          //   this.back();
          // }
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    loadingLoad: false,
    dialogDelete: false,
    dialogHide: false,
    dataClass: '',
    itemDelete: '',
    itemHide: '',
    show: false,
    form: {
      model: '',
      title: ' '
    },
    datas: '',
    titleData: '',
    comments: {
      parent: '',
      child: '',
      grandchild: '',
      greatGrandchild: '',
      great2Grandchild: ''
    }
  }),
  methods: {
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Discussion/fetchDetailView', this.$route.params.id)
        .then(res => {
          if (res) {
            res.addComment = false;
            this.datas = res;
            if (res.hide) {
              if (this.user.roleId === 5) {
                this.back();
              }
            }
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    submitData(item) {
      const input = {
        comment: item.komen,
        parentId: item.commentId ? item.commentId : null
      };

      this.loadingLoad = true;
      const payload = { id: this.$route.params.id, ...input };

      this.$store
        .dispatch(`Discussion/${item.typeSubmit ? 'updateComment' : 'postComment'}`, payload)
        .then(() => {
          item.komen = '';
          item.addComment = false;
          this.getData();
        })
        .finally(() => (this.loadingLoad = false));
    },
    deleteComment() {
      const input = {
        parentId: this.itemDelete.commentId ? this.itemDelete.commentId : null
      };
      this.loadingLoad = true;
      const payload = { id: this.$route.params.id, ...input };
      this.$store
        .dispatch(`Discussion/deleteComment`, payload)
        .then(() => {
          this.itemDelete.addComment = false;
          this.dialogDelete = false;
          this.getData();
        })
        .finally(() => (this.loadingLoad = false));
    },
    hideComment() {
      const input = {
        parentId: this.itemHide.commentId ? this.itemHide.commentId : null,
        childCommentHidden: this.itemHide.childCommentHidden
      };
      this.loadingLoad = true;
      const payload = { id: this.$route.params.id, ...input };
      this.$store
        .dispatch(`Discussion/hideComment`, payload)
        .then(() => {
          this.itemHide.addComment = false;
          this.dialogHide = false;
          this.getData();
        })
        .finally(() => (this.loadingLoad = false));
    },
    dialogDeletePop(item) {
      this.itemDelete = item;
      this.dialogDelete = true;
    },
    dialogHidePop(item) {
      this.itemHide = item;
      this.dialogHide = true;
    },
    dialogDeleteBack() {
      this.itemDelete = '';
      this.dialogDelete = false;
    },
    dialogHideBack() {
      this.itemHide = '';
      this.dialogHide = false;
    },
    dropDownAdd(item) {
      item.addComment = !item.addComment;
      item.komen = '';
      item.typeSubmit = false;
      this.resetComments();
    },
    dropDown(item) {
      item.addComment = !item.addComment;
      item.komen = item.comment;
      item.typeSubmit = true;
    },
    back() {
      if (this.isClass && !this.isStudent) {
        if (this.$route.params.classSectionId) {
          this.$router.push({ name: 'DiscussionSectionIndexClass' });
        } else {
          this.$router.push({ name: 'DiscussionIndexClass' });
        }
      } else if (this.isClass && this.isStudent) {
        if (this.$route.params.classSectionId) {
          this.$router.push({ name: 'DiscussionStudentSectionIndexClass' });
        } else {
          this.$router.push({ name: 'DiscussionStudentIndexClass' });
        }
      } else {
        this.$router.push({ name: 'DiscussionIndex' });
      }
    },
    resetComments() {
      this.comments = {
        parent: '',
        child: '',
        grandchild: '',
        greatGrandchild: '',
        great2Grandchild: '',
        great3Grandchild: ''
      };
    }
  },
  created() {
    if (this.isClass) {
      this.getData();
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}

.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.user {
  &-photo {
    width: 48px;
    height: 48px;
    overflow: hidden;
    border-radius: 100px;
    margin-right: 10px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.body-content-date {
  color: #fa6400;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.reply-card {
  background-color: #b2ebd0;
  border-radius: 8px;
}
</style>
